import crud from '@/crud/form/form'
import resources from '../../resources'

import components from './components'
import computed from './computed'
import methods from './methods'
import data from './data'
import mounted from './mounted'

export default {
  components,
  data,
  computed,
  methods,
  mounted,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/form/resources/index.js